export default "__VITE_ASSET__CRk6Fc$6__"